import React from 'react';
import axios from 'axios';
import { console_log, routeConfig } from '../../config';
import { alertInitialState, alertProps, useBoolean, useCount } from '..';
import {
    useFetchType,
    fetchReturnType,
    fetchHandlerType,
    dataResponse
} from './useFetch.types';
export const returnHandler: fetchReturnType = (res, msg, data = null) => ({
    success: res,
    msg: msg,
    data: data
});
export interface getResponseProps {
    loading: boolean;
    alert: alertProps;
    closeAlert: () => void;
}

export const getResponseInitialState: getResponseProps = {
    loading: true,
    alert: alertInitialState,
    closeAlert: () => {}
};

export const useFetch: useFetchType = (
    pathname,
    method,
    defaultLoading = false
) => {
    const [loading, toggleLoading] = useBoolean(defaultLoading);
    const [count, setCount] = useCount(0);

    const fetchHandler: fetchHandlerType = React.useCallback(
        async opt => {
            toggleLoading(true);
            const url =
                opt?.q && opt.ext
                    ? pathname + `/${opt.ext})?${opt.q}`
                    : opt?.ext
                    ? pathname + `/${opt.ext})`
                    : opt?.q
                    ? pathname + `?${opt.q}`
                    : pathname;
            try {
                const response = await axios({
                    method: method,
                    baseURL: routeConfig.baseServiceUrl,
                    url: url,
                    ...opt
                });
                console_log(`[${method}] ${url}:\n`, response);
                const data: dataResponse = response.data as dataResponse;
                return data.result === 'error'
                    ? method === 'GET' && count < 5
                        ? (() => {
                              setCount('inc');
                              return returnHandler(0, 'Error Count', count);
                          })()
                        : returnHandler(0, data.result, data.data)
                    : returnHandler(1, 'Success', data.data);
            } catch (error) {
                console_log(
                    `[${method}] `,
                    routeConfig.baseServiceUrl,
                    url,
                    ': CATCH ERROR\n',
                    error
                );
                return returnHandler(0, 'Catch Error', error);
            } finally {
                toggleLoading(false);
            }
        },
        [toggleLoading, pathname, method, count, setCount]
    );

    return [fetchHandler, loading];
};
